require(`./src/styles/global.css`)
const React = require(`react`)
const { MotionConfig } = require(`framer-motion`)
const ErrorBoundary = require(`./src/components/ErrorBoundary`).default
const { AlertsProvider } = require(`./src/context/alerts`)
const { ExportsProvider } = require(`./src/context/exports`)

// onClientEntry runs when the framework initialises on the client, and should only
// run once per hard refresh so this should be a safe way to inject the script dynamically.
exports.onClientEntry = () => {
  const isProduction = window.location.host.includes(`www.wolfandbadger.com`)
  const segmentId = isProduction
    ? process.env.GATSBY_SEGMENT_ID
    : process.env.GATSBY_SEGMENT_DEV_ID
  if (segmentId) {
    const script = document.createElement(`script`)
    script.innerHTML = `
      !function(){
        var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="${segmentId}";;analytics.SNIPPET_VERSION="4.15.3";
        analytics.load("${segmentId}");
      }}();
    `
    document.head.appendChild(script)
    // Allow anything else that may depend on the analytics script to run
    // to listen for when the script has loaded.
    const event = new CustomEvent(`segment-loaded`)
    document.dispatchEvent(event)
  }

  // Clear flash message store
  try {
    window.localStorage.removeItem(`dismissed-flash-messages`)
  } catch {
    /* empty */
  }
}

// This will run any time the route changes, including the initial route load
// which is why we can omit the typical analytics.page() call in the base script.
exports.onRouteUpdate = () => {
  const isProduction = window.location.host.includes(`www.wolfandbadger.com`)
  const segmentId = isProduction
    ? process.env.GATSBY_SEGMENT_ID
    : process.env.GATSBY_SEGMENT_DEV_ID
  if (segmentId) {
    window.setTimeout(() => {
      if (window.analytics) {
        window.analytics.page(document.title)
      }
    }, 50)
  }
}

exports.wrapPageElement = ({ element, ...props }) => (
  <ErrorBoundary {...props}>
    <MotionConfig reducedMotion="user">
      <AlertsProvider>
        <ExportsProvider>{element}</ExportsProvider>
      </AlertsProvider>
    </MotionConfig>
  </ErrorBoundary>
)
